import React, { useState } from 'react'
import { useStore } from '../../store/store';
import { Button } from 'antd';
import Tooltip from '../common/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { pageBackground } from '../../constants/constants';
import { iconButtonStyle, navbarButtonStyle } from '../../utils/styles';
import { useTranslation } from 'react-i18next';

const selector = (id) => ({ containers, updateContainer, currentDocument, currentTemplate }) => {
  const container = containers.find((c) => c.id === id);
  return {
    container,
    updateContainer,
    currentDocument,
    currentTemplate,
  };
};

const NoRepeatContainerButton = ({ id }) => {
  const { container, updateContainer, currentDocument, currentTemplate } = useStore(selector(id));
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  // Le flag noRepeat n'a d'effet que sur le contenu bouclé (modèles opportunity/section),
  // pas sur le template d'offre lui-même (qui porte le placeholder RECURSIVE_MODEL).
  if (
    currentDocument?.type !== 'template' ||
    currentTemplate?.templatable === 'offer' ||
    !container
  )
    return null;

  // Le contenu d'une section liée n'est pas enregistré dans ce modèle, il est redéplié
  // depuis sa source : le flag posé ici serait perdu, et l'injection lit celui de la source.
  const isLinked = !!container.from_linked_section;

  const toggleNoRepeat = () => {
    updateContainer({
      id: container.id,
      fn: (c) => {
        c.noRepeat = !c.noRepeat;
      },
    });
  };

  return (
    <Tooltip
      open={isHovered}
      placement='bottom'
      mouseLeaveDelay='0'
      title={t(
        isLinked
          ? 'container-no-repeat-linked'
          : container.noRepeat
            ? 'container-repeat-enable'
            : 'container-no-repeat'
      )}
    >
      {/* Pas de NavbarButton : un bouton désactivé ne reçoit pas le survol, or
          l'infobulle explique justement pourquoi il l'est (section liée). Même
          rendu que ses voisins de la barre du container, désactivé compris. */}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Button
          data-role={pageBackground}
          onClick={toggleNoRepeat}
          disabled={isLinked}
          style={navbarButtonStyle}
        >
          {/* Taille posée sur le calque : ses icônes, en absolu, s'y centrent ;
              plus grandes que lui, elles débordaient en bas à droite. */}
          <span
            className='fa-layers fa-fw'
            style={{
              fontSize: 18,
              color: container.noRepeat ? '#cf1322' : iconButtonStyle().color,
              opacity: isLinked ? 0.3 : 1,
            }}
          >
            <FontAwesomeIcon icon={icon({ name: 'arrows-repeat', style: 'light' })} />
            {container.noRepeat && (
              <FontAwesomeIcon icon={icon({ name: 'slash', style: 'light' })} />
            )}
          </span>
        </Button>
      </div>
    </Tooltip>
  );
};

export default NoRepeatContainerButton;
